import { Button } from '@/components/Button'
import { Form } from '@/components/Form'
import { Input } from '@/components/Input'
import { CommonError } from '@/shared/Auth/components/CommonError'
import { Row } from '@/shared/Auth/components/Row'
import { Title } from '@/shared/Auth/components/Title'
import { FC } from 'react'
import styles from './Login.module.scss'

interface LoginProps {
  className?: string
  email: string
  password: string
  isLoading?: boolean
  errors?: {
    _common?: string
    email?: string
    password?: string
  }
  changeEmail: (value: string, name: string) => void
  changePassword: (value: string, name: string) => void
  onLogin?: () => void
  goToResetPassword?: () => void
}
export const Login: FC<LoginProps> = ({
  className,
  email = '',
  isLoading = false,
  password = '',
  errors = {},
  changeEmail,
  changePassword,
  onLogin = () => {},
  goToResetPassword = () => {},
}) => {
  return (
    <Form onSubmit={onLogin} className={className}>
      <Title title="Вход в личный кабинет" />

      <Row>
        <CommonError errors={errors} />
      </Row>

      <Row>
        <Input
          value={email}
          onChange={changeEmail}
          type="email"
          name="email"
          error={errors.email}
          placeholder={'E-mail'}
        />
      </Row>

      <Row>
        <Input
          value={password}
          onChange={changePassword}
          type="password"
          name="password"
          error={errors.password}
          placeholder={'Пароль'}
        />
      </Row>

      <Row>
        <Button
          className={styles.button}
          isLoading={isLoading}
          type="submit"
          name="Войти"
          testId="loginButton"
        />
      </Row>

      <button type="button" onClick={goToResetPassword} className={styles.link}>
        Забыли пароль?
      </button>
    </Form>
  )
}
